import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/email-history/profile/loading';

export const Route = createFileRoute('/_private/settings/email-history/$id')({
  pendingComponent: Loading,
});
